var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoNetworkError = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "161px",
    height: "128px",
    viewBox: "0 0 161 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wifi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Network-error",
    transform: "translate(-770.000000, -457.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wifi",
    transform: "translate(770.000000, 457.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.115951, 0.000000)",
    fill: "#BFBFBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.272218,31.4737739 C121.756172,11.599846 96.5874464,0.150643275 70.0968265,0.00627680312 C43.6102865,0.153781676 18.4468967,11.6026706 0.934615984,31.4737739 C-0.346793372,32.8063392 -0.305366472,34.9257018 1.02719883,36.2071111 C2.35976413,37.4885205 4.47912671,37.4470936 5.76053606,36.1145283 C5.80478752,36.0687076 5.84746979,36.0213177 5.88921053,35.9729864 C22.1398538,17.5082008 45.4999181,6.85866277 70.0968265,6.70142885 C94.7003255,6.86368421 118.063528,17.5235789 134.311033,35.9999766 C135.592442,37.3325419 137.711805,37.3739688 139.04437,36.0925595 C140.323583,34.8626199 140.420559,32.8480799 139.265628,31.5007641 L139.272218,31.4737739 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1034172,26.7871988 C50.2053236,26.9004951 31.3021033,35.5041092 18.1481209,50.4347407 C16.8667115,51.767306 16.9081384,53.8866686 18.2407037,55.168078 C19.573269,56.4494873 21.6926316,56.4080604 22.9740409,55.0754951 C23.0182924,55.0296745 23.0609747,54.9822846 23.1027154,54.9339532 C34.9944327,41.4093255 52.0946413,33.6047485 70.1034172,33.4823509 C88.1084269,33.5962749 105.208322,41.3911228 117.104119,54.9072768 C118.307382,56.3110838 120.420782,56.4733392 121.824589,55.270076 C123.228396,54.0668129 123.390651,51.9534133 122.187388,50.5496062 C122.145961,50.5012749 122.102965,50.453885 122.058713,50.4080643 C108.901906,35.4846511 89.9980585,26.8901384 70.1034172,26.7871988 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3616257,69.3690312 C34.0802164,70.7015965 34.1216433,72.8209591 35.4542086,74.1023684 C36.7867739,75.3837778 38.9061365,75.3423509 40.1875458,74.0097856 C40.2317973,73.9639649 40.2744795,73.916575 40.3162203,73.8682437 C54.2792827,57.769499 78.4882846,55.6316199 95.0565341,69.0341637 C96.4512398,70.2477836 98.5655809,70.1012203 99.7795146,68.7065146 C100.966772,67.3422515 100.855986,65.281577 99.5290702,64.0528928 C80.2005965,48.2488441 51.8256803,50.5995068 35.3616257,69.3690312 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 70.1034172,
    cy: 97.0873938,
    r: 16.738037
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CBCBCB",
    cx: 123.455132,
    cy: 90.3859649,
    r: 36.7192982
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(106.507764, 73.438596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3502261,33.6916823 C29.4617446,33.6932515 28.6090409,33.3417505 27.9801053,32.7140702 L1.19918324,5.93314815 C-0.0853645224,4.60340741 -0.048331384,2.48404483 1.28140936,1.19949708 C2.57882456,-0.0536666667 4.6354191,-0.0536666667 5.93283431,1.19949708 L32.7137563,27.9804191 C34.0227836,29.2859942 34.0252943,31.4056706 32.7197193,32.7146979 C32.0901559,33.3458304 31.2349415,33.6998421 30.3436355,33.6982781 L30.3502261,33.6916823 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56930409,33.6916882 C1.72047173,33.6951345 0.219060429,32.1987446 0.215602993,30.3499123 C0.214038986,29.4586062 0.568050682,28.6033918 1.19918324,27.9738285 L27.9801053,1.19290643 C29.309846,-0.0916413255 31.4292086,-0.0546081871 32.7137563,1.27513255 C33.9669201,2.57254776 33.9669201,4.6291423 32.7137563,5.9265575 L5.93283431,32.7074795 C5.30640936,33.3357875 4.45621637,33.6897992 3.56930409,33.6916882 Z",
    id: "Path",
    fill: "#FAFAFA"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoNetworkError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_network_error.fd68c7215905de81a2bce63ce363965f.svg";